import React from 'react';
import './item-producto.css';

function createSkeleton() {
  return (
    <div className='content-item'>
      <h1 className='text-center'><span style={{ color: '#eaeaea' }}>Loading...</span></h1>
    </div>
  );
}

const ItemProducto = (props) => {
  const { data, voucherData } = props;
  if (!data) return createSkeleton();
  const { producto } = data;
  const productoDetallUrl = `${process.env.RAZZLE_URL_PATH}/open-voucher/producto-detalle/${voucherData.tipoVoucher.id}/${voucherData.id}/${producto.id}`;
  const isValid = (item) => item && item !== '' && item !== ' ';

  return (
    <div className='content-item'>
      <a
        href={productoDetallUrl}
        target='_blank'
        rel='noopener noreferrer'
        className='default'
      >
        <div className='position-relatives'>
          {producto.label && producto.label !== '' && (
            <span className='label-info'>
              <span className='text'>{producto.label}</span>
            </span>
          )}
          <img
            className='img-responsive reference-img'
            src={producto.imagenUrl}
            alt=''
          />
        </div>
        <div className='prod-information'>
          <h4 className='title clamp-one'>{producto.nombre}</h4>
          <h5 className='sub-title clamp-one'>
            {producto.localidad}
            {' '}
            |
            {' '}
            {producto.provincia}
          </h5>
          {isValid(producto.categoria) && (<p className='aditional'>{producto.categoria}</p>)}
          {isValid(producto.extras) && (<div className='extra'>{producto.extras}</div>)}
        </div>
      </a>
    </div>
  );
};

export default ItemProducto;
